export default {
  en: {
    language: {
      name: 'Language',
      title: 'Select Language',
      description: 'Select system language.',
    },
    room: {
      name: 'Room',
    },
    back: {
      name: 'Back',
    },
    channel: {
      name: 'Channel',
    },
    dateISO: 'en-GB',
  },
  de: {
    language: {
      name: 'Sprache',
      title: 'Sprache auswählen',
      description: 'Wählen Sie die Systemsprache.',
    },
    room: {
      name: 'Zimmer',
    },
    back: {
      name: 'Zurück',
    },
    channel: {
      name: 'Kanal',
    },
    dateISO: 'de-DE',
  },
  ch_de: {
    language: {
      name: 'Sprache',
      title: 'Sprache auswählen',
      description: 'Wählen Sie die Systemsprache.',
    },
    room: {
      name: 'Zimmer',
    },
    back: {
      name: 'Zurück',
    },
    channel: {
      name: 'Kanal',
    },
    dateISO: 'de-CH',
  },
  ch_fr: {
    language: {
      name: 'Langue',
      title: 'Sélection de la langue',
      description: 'Sélectionner la langue du système.',
    },
    room: {
      name: 'Salle',
    },
    back: {
      name: 'Retour',
    },
    channel: {
      name: 'Chaîne',
    },
    dateISO: 'fr-CH',
  },
  ch_it: {
    language: {
      name: 'Lingua',
      title: 'Selezionare la lingua',
      description: 'Selezionare la lingua del sistema.',
    },
    room: {
      name: 'Camera',
    },
    back: {
      name: 'Indietro',
    },
    channel: {
      name: 'Canale',
    },
    dateISO: 'it-CH',
  },
  fr: {
    language: {
      name: 'Langue',
      title: 'Sélection de la langue',
      description: 'Sélectionner la langue du système.',
    },
    room: {
      name: 'Salle',
    },
    back: {
      name: 'Retour',
    },
    channel: {
      name: 'Chaîne',
    },
    dateISO: 'fr-FR',
  },
  it: {
    language: {
      name: 'Lingua',
      title: 'Selezionare la lingua',
      description: 'Selezionare la lingua del sistema.',
    },
    room: {
      name: 'Camera',
    },
    back: {
      name: 'Indietro',
    },
    channel: {
      name: 'Canale',
    },
    dateISO: 'it-IT',
  },
  es: {
    language: {
      name: 'Idiomas',
      title: 'Seleccionar idioma',
      description: 'Seleccionar idioma del Sistema',
    },
    room: {
      name: 'Habitación',
    },
    back: {
      name: 'Volver',
    },
    channel: {
      name: 'Canal',
    },
    dateISO: 'es-ES',
  },
  tr: {
    language: {
      name: 'Dil',
      title: 'Dil Seçiniz',
      description: 'Sistem dilini seçin.',
    },
    room: {
      name: 'Oda',
    },
    back: {
      name: 'Geri',
    },
    channel: {
      name: 'Kanal',
    },
    dateISO: 'tr-TR',
  },
  ru: {
    language: {
      name: 'Язык',
      title: "Выбрать язык",
      description: "Выберите язык системы.",
    },
    room: {
      name: 'Комната',
    },
    back: {
      name: 'Назад',
    },
    channel: {
      name: 'Канал',
    },
    dateISO: 'ru-RU',
  },
  nl: {
    language: {
      name: 'Taal',
      title: "Selecteer taal",
      description: "Selecteer de systeemtaal.",
    },
    room: {
      name: 'Kamer',
    },
    back: {
      name: 'Terug',
    },
    channel: {
      name: 'Kanaal',
    },
    dateISO: 'nl-NL',
  },
  ar: {
    language: {
      name: 'اللغة',
      title: "تحديد اللغة",
      description: "حدد لغة النظام.",
    },
    room: {
      name: 'الغرفة',
    },
    back: {
      name: 'الخلفية',
    },
    channel: {
      name: 'القناة',
    },
    dateISO: 'ar-SY',
  },
  ko: {
    language: {
      name: '언어',
      title: "언어 선택",
      description: "시스템 언어를 선택합니다.",
    },
    room: {
      name: '방',
    },
    back: {
      name: '뒤로',
    },
    channel: {
      name: '채널',
    },
    dateISO: 'ko-KR',
  },
  el: {
    language: {
      name: 'γλώσσα',
      title: "Επιλέξτε γλώσσα",
      description: "Επιλέξτε τη γλώσσα του συστήματος.",
    },
    room: {
      name: 'Δωμάτιο',
    },
    back: {
      name: 'Πίσω στο',
    },
    channel: {
      name: 'Κανάλι',
    },
    dateISO: 'el-GR',
  },
  pt: {
    language: {
      name: 'Língua',
      title: "Selecionar o idioma",
      description: "Selecionar o idioma do sistema.",
    },
    room: {
      name: 'Sala',
    },
    back: {
      name: 'Voltar para',
    },
    channel: {
      name: 'Canal',
    },
    dateISO: 'pt-PT',
  },
  hu: {
    language: {
      name: 'Nyelv',
      title: "Nyelv kiválasztása",
      description: "Válassza ki a rendszer nyelvét.",
    },
    room: {
      name: 'Szoba',
    },
    back: {
      name: 'Vissza a',
    },
    channel: {
      name: 'Csatorna',
    },
    dateISO: 'hu-HU',
  },
  da: {
    language: {
      name: 'Sprog',
      title: "Vælg sprog",
      description: "Vælg systemets sprog.",
    },
    room: {
      name: 'Rum',
    },
    back: {
      name: 'Tilbage til',
    },
    channel: {
      name: 'Kanal',
    },
    dateISO: 'da-DK',
  },
  sv: {
    language: {
      name: 'Språk',
      title: "Välj språk",
      description: "Välj systemets språk.",
    },
    room: {
      name: 'Rum',
    },
    back: {
      name: 'Tillbaka till',
    },
    channel: {
      name: 'Kanal',
    },
    dateISO: 'sv-SE',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js